import type { AssetStatus } from '@/enum/AssetStatus'
import type { OwnershipType } from '@/enum/OwnershipType'
import type { IAppUser, IDimensionSpecifications, IMachine } from '@/interfaces'
import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'
import type { IEngineSpecifications } from '@/interfaces/IEngineSpecifications'
import type { IFuelEconomySpecifications } from '@/interfaces/IFuelEconomySpecifications'
import type { IWheelsAndTiresSpecifications } from '@/interfaces/IWheelsAndTiresSpecifications'
import WheelsAndTiresSpecifications from '@/models/WheelsAndTiresSpecifications'
import { DimensionSpecifications } from '@/models'
import Base from '@/models/Base'
import EngineSpecifications from '@/models/EngineSpecifications'
import FuelEconomySpecifications from '@/models/FuelEconomySpecifications'
import DecimalValueAndUnit from '../DecimalValueAndUnit'

class Machine extends Base implements IMachine {
  title: string
  avatarUrl: string
  registration: string
  make: string
  model: string
  year: number
  type: string
  status: AssetStatus
  assignedEmployeeId: string
  assignedEmployee: IAppUser | null
  odometerReading: IDecimalValueAndUnit
  machineHours: number
  ownership: OwnershipType
  fitnessValidUpto: string
  commissionDate: string
  decommissionDate: string
  dimensionSpecifications: IDimensionSpecifications
  engineSpecifications: IEngineSpecifications
  fuelEconomySpecifications: IFuelEconomySpecifications
  wheelsAndTiresSpecifications: IWheelsAndTiresSpecifications

  constructor(machine?: any) {
    super(machine)
    this.title = machine?.title
    this.avatarUrl = machine?.avatarUrl
    this.registration = machine?.registration
    this.make = machine?.make
    this.model = machine?.model
    this.year = machine?.year
    this.type = machine?.type
    this.status = machine?.status
    this.assignedEmployeeId = machine?.assignedEmployeeId
    this.assignedEmployee = machine?.assignedEmployee
    this.odometerReading = new DecimalValueAndUnit(machine?.odometerReading)
    this.machineHours = machine?.machineHours
    this.ownership = machine?.ownership
    this.fitnessValidUpto = machine?.fitnessValidUpto
    this.commissionDate = machine?.commissionDate
    this.decommissionDate = machine?.decommissionDate
    this.dimensionSpecifications = new DimensionSpecifications(machine?.dimensionSpecifications)
    this.engineSpecifications = new EngineSpecifications(machine?.engineSpecifications)
    this.fuelEconomySpecifications = new FuelEconomySpecifications(
      machine?.fuelEconomySpecifications
    )
    this.wheelsAndTiresSpecifications = new WheelsAndTiresSpecifications(
      machine?.wheelsAndTiresSpecifications
    )
  }
}

export default Machine
